import Repository from "./Repository";

export default {
  // List Project Schedules
  getProjectSchedules(payload) {
    return Repository.get(`/project/${payload.id}/schedule`, {
      params: {
        page: payload ? payload.page : 1,
        size: payload ? payload.size : 10
      }
    });
  },

  // Get Project Schedule
  getProjectSchedule(payload) {
    return Repository.get(`/project/${payload.id}/schedule/${payload.name}`);
  },

  // Get Project Schedule Levels
  getProjectScheduleLevels(payload) {
    return Repository.get(
      `/project/${payload.id}/schedule/${payload.name}/version/${payload.version}/level`
    );
  },

  // Get Project Schedule item Groups
  getProjectScheduleItemGroups(payload) {
    return Repository.get(
      `/project/${payload.id}/schedule/${payload.name}/version/${payload.version}/item_group`
    );
  },

  // Get Project Schedule items
  getProjectScheduleItems(payload) {
    return Repository.get(
      `/project/${payload.id}/schedule/${payload.name}/version/${payload.version}/item`,
      {
        params: {
          page: payload.page ? payload.page : 1,
          size: payload.size ? payload.size : 99999
        }
      }
    );
  }
};
